import { Grounds } from "./type";

export function newGrounds(): Grounds {
    return {
        id: undefined,
        dedicated_indoor_garage: null,
        dedicated_outdoor_garage: null
    }
}